import React, { FunctionComponent } from "react";
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from "react-i18next";
import cs from "classnames";
import { links } from "/src/domain/shared/links";

interface TrainerBannerProps {
    className?: string;
}

export const TrainerBanner: FunctionComponent<TrainerBannerProps> = ({ className }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <a className={cs(classes.trainerBanner, className)} href={`${links.origin}/trainerlist`}>
            <img width="100%" src={require('../../assets/icons/trainer_banner.jpg')} alt="trainer_banner"/>
        </a>
    )
}

const useStyles = makeStyles({
    trainerBanner: {
        display: "block",
    }
})